import * as yup from 'yup'
import { format } from 'react-string-format'

const Yup = (t) => {
  yup.setLocale({
    mixed: {
      required: props => format(t('validation_message_required'), props.path)
    },
    string: {
      max: props => format(t('validation_message_max'), props.label, props.max),
      min: props => format(t('validation_message_min'), props.label, props.min),
      email: props => format(t('validation_message_email'), props.label, props.min)
    },
    array: {
      max: props => format(t('validation_message_max_array'), props.label, props.max),
      min: props => format(t('validation_message_min_array'), props.label, props.min)
    }
  })
  return yup
}

export default Yup
